import {Component, model} from "@angular/core";
import { DrawerModule } from "primeng/drawer";
import { PrimeTemplate } from "primeng/api";
import { TableModule } from "primeng/table";
import { MessageModule } from "primeng/message";
import { Button } from "primeng/button";
import { TranslatePipe } from "../../_pipes/translate.pipe";

interface LocationData {
  label: string;
  value: string;
}

@Component({
    selector: "app-data-location-modal",
    templateUrl: "./data-location-modal.component.html",
    imports: [DrawerModule, PrimeTemplate, TableModule, MessageModule, Button, TranslatePipe]
})
export class DataLocationModalComponent {
  readonly visible = model<boolean>(false);

  locationData: LocationData[] = [
    {
      label: 'data_location_network_servers',
      value: 'data_location_network_servers_value'
    },
    {
      label: 'data_location_ip_location',
      value: 'data_location_ip_location_value'
    },
    {
      label: 'data_location_company_managing_data',
      value: 'data_location_company_managing_data_value'
    }
  ];

  constructor() {}

  closeModal() {
    this.visible.set(false);
  }
}
